import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ||============================== //

const Logo = () => {
    const theme = useTheme();
    const color = theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000';

    return (
        <span style={{ fontSize: 28, fontWeight: 700, color, letterSpacing: 3, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
            DEEP
        </span>
    );
};

export default Logo;
